export default {
      id: "ic-misc-target-usage",
      viewBox: "0 0 60 60",
      url: "../dist/images/" + "sprite.svg#ic-misc-target-usage",
      toString: function () {
        return this.url;
      }
    }